import { IAutoMapper } from "../interfaces";

export const mapUserGroupModel = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "UserGroupItem")
    .forMember("groupName", o => o.groupName)
    .forMember("userChatGroup", o => o.userChatGroup);

};
